import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import { makeInput } from "common-import/custom";
import { inject, observer } from "mobx-react";

import { TimeHelper, VarHelper } from "common-import/helpers"
import { List } from "common-import/templates"

@inject("cartOrderStore", "userStore") @observer
class OrderWaitingList extends List {

  store = this.props.cartOrderStore;

  messageNotFound = "Hiện chưa có đơn hàng nào đợi payment";

  listData = () => this.store.list_WAITING;

  onReady = () => {
    this.store.getListStatus("WAITING", 1);
  }

  getList = (page) => {
    this.store.getListStatus("WAITING", page);
  }

  renderRow(data, index) {
    const total = (() =>  {
			let value = 0;
			data.cart.slice().forEach((item, i) => {
				value = value + item.product.price * item.amount;
			});
			return value;
		})();
    return (
      <tr key={"row"+index}>
        <td>
          <Link to={`/order/${data.id}`}>
            <div><strong>{data.id}</strong></div>
            <div>Total: <b style={{color: 'red'}}>{VarHelper.moneyString(total)}</b></div>
          </Link>
        </td>
        <td>
          <div className="clearfix">
            <div >{data.shipInfo.name}</div>
            <div className="small text-muted">
              <span>Phone</span>: <b>{String(data.shipInfo.phone)}</b>
            </div>
            <div className="small text-muted">
              <span>Email</span>: <b>{String(data.shipInfo.email)}</b>
            </div>
          </div>
        </td>
        <td>
          <a >
            {
              data.cart.map((val, i) => (
                <div className="one-row" key={val.product.name+'i'} style={{maxWidth: 300}}>{val.product.name}</div>
              ))
            }
            
            {/* <div className="small text-muted">
              <span>Fax</span>: {data.fax}
            </div> */}
          </a>
        </td>
        <td>
          <div className="small text-muted">{data.status}</div>
        </td>
        <td>
          <div className="small text-muted">{TimeHelper.toDateString(data.updatedAt)}</div>
        </td>
      </tr>

    )
  }

  renderTabletTitle = () => {
    return (
      <tr>
        <th>ID / Money</th>
        <th>Shipping Info</th>
        <th>Cart Info</th>
        <th>Status</th>
        <th>Update At</th>
      </tr>
    );
  }


}

export default OrderWaitingList;


// WEBPACK FOOTER //
// ./src/views/Shop/OrderWaitingList.js